.EventBanner {
  position: relative;
  height: 16rem;
  border-radius: 0.375rem;
  overflow: hidden;
  justify-content: center;
  align-items: center;
  width: 100%;
  display: flex;

  @media (min-width: 1267px) {
    height: 24rem;
  }

  & > img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
}
